import { call, put, takeLatest } from "redux-saga/effects";
import apiCall from "../services"
import config from '../config/config.json';

const endpoint = `${config.credentials.url}/executive-goal`;

function* getExecutiveGoalList(actions) {
    try {
        const headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${actions.access}`,
        };

        const query = actions.query ? actions.query : "";
        const url = `${endpoint}/${query}`;

        const response = yield call(apiCall, "GET", url, { headers });

        yield put({
            type: "EXECUTIVE_GOAL_LIST_RESPONSE",
            value: response,
        });

    } catch (error) {
        yield put({
            type: "EXECUTIVE_GOAL_ERROR",
            error,
        });
    }
}

function* getExecutiveGoalDetail(actions) {
    try {
        const headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${actions.access}`,
        };

        const url = `${endpoint}/${actions.id}/`;

        const response = yield call(apiCall, "GET", url, { headers });

        yield put({
            type: "EXECUTIVE_GOAL_DETAIL_RESPONSE",
            value: response,
        });

    } catch (error) {
        yield put({
            type: "EXECUTIVE_GOAL_ERROR",
            error,
        });
    }
}

function* createExecutiveGoal(actions) {
    try {
        const headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${actions.access}`,
        };

        const requestOptions = {
            headers,
            body: JSON.stringify(actions.payload),
        };

        const response = yield call(
            apiCall,
            "POST",
            `${endpoint}/`,
            requestOptions
        );

        yield put({
            type: "EXECUTIVE_GOAL_CREATE_RESPONSE",
            value: response,
        });
    } catch (error) {
        yield put({
            type: "EXECUTIVE_GOAL_CREATE_ERROR",
            error,
        });
    }
}

function* updateExecutiveGoal(actions) {
    try {
        const headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${actions.access}`,
        };

        const requestOptions = {
            headers,
            body: JSON.stringify(actions.payload),
        };

        const response = yield call(
            apiCall,
            "PATCH",
            `${endpoint}/${actions.id}/`,
            requestOptions
        );

        yield put({
            type: "EXECUTIVE_GOAL_UPDATE_RESPONSE",
            value: response,
        });
    } catch (error) {
        yield put({
            type: "EXECUTIVE_GOAL_UPDATE_ERROR",
            error,
        });
    }
}

export default function* sagaExecutiveGoal() {
    yield takeLatest("EXECUTIVE_GOAL_LIST_REQUEST", getExecutiveGoalList);
    yield takeLatest("EXECUTIVE_GOAL_DETAIL_REQUEST", getExecutiveGoalDetail);
    yield takeLatest("EXECUTIVE_GOAL_CREATE_REQUEST", createExecutiveGoal);
    yield takeLatest("EXECUTIVE_GOAL_UPDATE_REQUEST", updateExecutiveGoal);
}
